import * as ActionTypes from "./actionTypes";

export const receiveEventsSnapshot = events => {
  return {
    type: ActionTypes.RECEIVE_EVENTS_SNAPSHOT,
    events
  };
};
